import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DashboardPage from '../../features/dashboard/pages/DashboardPage';
import ClassesPage from '../../features/classes/pages/ClassesPage';
import ClassStudentsPage from '../../features/classes/pages/ClassStudentsPage';
import ClassLessonDetailsPage from '../../features/classes/pages/ClassLessonDetailsPage';
import StudentsPage from '../../features/students/pages/StudentsPage';
import TeachersPage from '../../features/teachers/pages/TeachersPage';
import ReportsPage from '../../features/reports/pages/ReportsPage';
import ReportDetailsPage from '../../features/reports/pages/ReportDetailsPage';
import ProfilePage from '../../features/profile/pages/ProfilePage';
import MorePage from '../../features/more/pages/MorePage';
import { AuthGate } from '../../features/auth/components/AuthGate';
import { AuthProvider } from '../../features/auth/context/AuthContext';
import { TrimestersProvider } from '../../features/trimesters/context/TrimestersContext';
import TrimestersPage from '../../features/trimesters/pages/TrimestersPage';
import SegmentsPage from '../../features/trimesters/pages/SegmentsPage';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthGate>
          <TrimestersProvider>
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/classes" element={<ClassesPage />} />
              <Route path="/classes/:classId/licoes/:lessonId" element={<ClassLessonDetailsPage />} />
              <Route path="/classes/:classId/:tab?" element={<ClassStudentsPage />} />
              <Route path="/alunos" element={<StudentsPage />} />
              <Route path="/professores" element={<TeachersPage />} />
              <Route path="/relatorios" element={<ReportsPage />} />
              <Route path="/relatorios/:reportId" element={<ReportDetailsPage />} />
              <Route path="/mais" element={<MorePage />} />
              <Route path="/trimestres" element={<TrimestersPage />} />
              <Route path="/trimestres/:trimesterId/revistas" element={<TrimestersPage />} />
              <Route path="/segmentos" element={<SegmentsPage />} />
              <Route path="/perfil" element={<ProfilePage />} />
            </Routes>
          </TrimestersProvider>
        </AuthGate>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
